import React from "react";
import { Helmet } from "react-helmet";

const DOMAIN = "https://seedtotree.netlify.app";
const MAIN_KEYWORDS =
  "tech, software, online academy, videos, Best online academy in Pakistan, Best online academy in Islamabad";
const DEFAULT_IMAGE_CARD =
  "https://seedtotree.netlify.app/assets/images/carousel/c1/c1-786.jpg";

const DEFAULT_TITLE = "SEED TO TREE: Tech Academy & Solutions";

const DEFAULT_DESCRIPTION =
  "Seed to Tree: Where education meets innovation. Top-tier academy & software house.";

const FAVICON_SOURCE = `${DOMAIN}/favicon.ico`;
const POSTFIX_TITLE = " | SEED TO TREE";

const HeadSection = ({
  title = DEFAULT_TITLE,
  content = DEFAULT_DESCRIPTION,
  showCanonical = false,
  link,
  keywords,
  imageCard = DEFAULT_IMAGE_CARD,
  largeTwitterCard,
  addPostFixTitle,
  noIndex,
  children,
}) => {
  let metaTitle;
  if (addPostFixTitle) {
    metaTitle = title + POSTFIX_TITLE;
  } else {
    metaTitle = title;
  }

  const metaContentDescription = content;

  let metaLink = link;
  if (metaLink.startsWith("https")) {
    metaLink = link;
  } else {
    metaLink = DOMAIN + link;
  }

  const metaKeywords =
    keywords && keywords !== ""
      ? MAIN_KEYWORDS + "," + keywords
      : MAIN_KEYWORDS;

  let metaImageCard;

  if (imageCard.startsWith("https")) {
    metaImageCard = imageCard;
  } else {
    metaImageCard = DOMAIN + imageCard;
  }

  const metaRobots = noIndex ? "noindex, nofollow" : "index, follow";

  const metaWebsiteUsername = "@seedtotree.info";

  const twitterCardType = largeTwitterCard ? "summary_large_image" : "summary";

  return (
    <Helmet>
      <html lang="en" />

      <meta charset="utf-8" />
      <meta name="fragment" content="!"></meta>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta http-equiv="content-language" content="en" />
      <title>{metaTitle}</title>
    
      {/* report-uri /csp-violation-report */}

      <meta name="description" content={metaContentDescription} />

      {/* To conditionally remove content duplication we use canonical tags*/}
      {showCanonical && <link rel="canonical" href={metaLink} />}

      {/* Favicon Icon of the website */}
      <link rel="icon" href={FAVICON_SOURCE} />

      {/* Meta Keywords */}
      <meta name="keywords" content={metaKeywords} />
      {/* Meta Robots if we want the page to be indexed or not */}
      <meta name="robots" content={metaRobots} />

      {/* Theme Description Tags */}
      <meta name="theme-color" content="#000000" />

      <link rel="apple-touch-icon" href={`${DOMAIN}/logo192.png`} />

      <link rel="manifest" href={`/manifest.json`} />

      {/* OG Tags for social media */}
      <meta property="og:url" content={metaLink} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaContentDescription} />
      <meta property="og:type" content={"website"} />
      <meta property="og:image" content={metaImageCard} />

      {/* Twitter tags */}
      <meta property="twitter:site" content={metaWebsiteUsername} />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={metaContentDescription} />
      <meta property="twitter:creator" content={"@sedtotree.info"} />
      <meta property="twitter:card" content={twitterCardType} />
      <meta property="twitter:image" content={metaImageCard} />

      {/* Referrer */}

      <meta name="referrer" content="origin-when-crossorigin" />

      {/* Google Adsens */}
      <meta name="google-adsense-account" content="ca-pub-3319455318350320" />
      <meta
        name="google-site-verification"
        content="9k3Y8wwY6APOMDqi1oapgV1mrPJtBPgQdFxz3kyS2xg"
      />

      {children}
    </Helmet>
  );
};

export default HeadSection;
